import { css } from 'styled-components';
import { map } from '../../breakpoint';
import { getSpacingFromTheme } from '../../spacing/core';
export function getSpacingValues(values) {
    return function({ theme }) {
        return getSpacingFromTheme(values, theme);
    };
}
export const gap = ()=>css`
  ${({ gap })=>map(gap, (val)=>val != undefined && css`
          gap: ${getSpacingValues(val)};
        `)};
`;
export const columnGap = ()=>css`
  ${({ columnGap })=>map(columnGap, (val)=>val != undefined && css`
          column-gap: ${getSpacingValues(val)};
        `)};
`;
export const rowGap = ()=>css`
  ${({ rowGap })=>map(rowGap, (val)=>val != undefined && css`
          row-gap: ${getSpacingValues(val)};
        `)};
`;

//# sourceMappingURL=gap.js.map